// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forget-password-text {
    margin: 31px 0px !important;
    text-align: right;
    color: var(--purple) !important;
    font-family: var(--Inter-Medium);
    letter-spacing: -0.28px;
    font-size: 14px;
}


@media(max-width:400px) {
    .forget-password-text {
        margin: 20px 0px !important
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/LoginPage.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,uBAAuB;IACvB,eAAe;AACnB;;;AAGA;IACI;QACI;IACJ;AACJ","sourcesContent":[".forget-password-text {\n    margin: 31px 0px !important;\n    text-align: right;\n    color: var(--purple) !important;\n    font-family: var(--Inter-Medium);\n    letter-spacing: -0.28px;\n    font-size: 14px;\n}\n\n\n@media(max-width:400px) {\n    .forget-password-text {\n        margin: 20px 0px !important\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
